//선박운항일지
import React, { useState } from "react";
import { Container } from "@mui/material";
import { CDate } from "../../../components/CDate";
import ManagerAppBar from "../common/ManagerAppBar";
import TabList from "./TabLsit";
import { addMonths, format, subMonths } from "date-fns";
import { mainColor } from "../../../assets/colors/color";
import { useRecoilValue } from "recoil";
import { getShipDataAdmin } from "../../../recoil/GetData";
import { loginAuthenticationAdmin } from "../../../hooks/loginAuthentication";
function ShipFlightLog() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const selectDay = format(selectedDate, "yyyy-M-dd");
  const year = format(currentMonth, "yyyy");
  const month = format(currentMonth, "MM");

  React.useEffect(() => {
    loginAuthenticationAdmin();
  }, []);

  const shipScheduleData = useRecoilValue(
    getShipDataAdmin(`${year}-${month}-23`)
  );

  console.log(shipScheduleData);

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };
  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const onDateClick = (day) => {
    setSelectedDate(day);
  };

  return (
    <div>
      <ManagerAppBar />
      <Container
        maxWidth="sm"
        sx={{
          position: "relative",
          marginTop: "76px",
          gap: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1 style={{ fontSize: "20px" }}>선박 운항 일지</h1>

        <CDate
          edata={shipScheduleData && shipScheduleData}
          onDateClick={onDateClick}
          selectedDate={selectedDate}
          prevMonth={prevMonth}
          nextMonth={nextMonth}
          currentMonth={currentMonth}
        />
        <p
          style={{
            fontSize: 20,
            fontWeight: 700,
            color: `${mainColor}`,
            padding: "8px 0",
          }}
        >
          선택된 날짜 : {selectDay}{" "}
        </p>

        <TabList
          edata={shipScheduleData && shipScheduleData}
          selectedDate={selectedDate}
          NextPageType={"ShipFlightLog"}
        />
      </Container>
    </div>
  );
}

export default ShipFlightLog;
